<template>
  <div>
    <div style="text-align: left; background-color: #EFF3FF; padding-left: 10px; padding-top: 1px; padding-bottom: 5px; font-size: 16px">
      <p style="font-size: 20px; font-weight: bold">猜字游戏</p>
      <p>在这个游戏中，你必须一个字母一个字母的猜出秘密单词。</p>
      <p>如果你猜错了一个字母，你将丢掉一条命。</p>
      <p>正如游戏名那样，你需要仔细选择字母，因为你的生命数量非常有限。</p>
    </div>
    <div style="display: flex; justify-content: space-between; width: 100%; margin-top: 10px">

      <div style="width: 800px;  text-align: left; color: white; font-size: 15px; line-height: 25px; ">
        <div style="color: white; text-align: left; font-weight: bold">示例代码：</div>
        <div style="padding: 10px; background-color: rgb(43, 43, 43); margin-top: 5px; height: 650px; overflow-y: auto">
          <!--<div  v-for="(item,index) in zcdCode" :key="index">
            <div :style="{textIndent: item.ml + 'em'}" style="margin-left: 10px">
              {{item.con}}
            </div>
          </div>-->
          <div>
            <p># -*- coding: utf-8 -*-</p>
            <p>"""</p>
            <p>Spyder Editor</p>
            <p>This is a temporary script file.</p>
            <p>"""</p>

            <p>import random</p>

            <p># 生命次数 </p>
            <p>lives = 3</p>
            <p>
              <br>
            </p>
            <p># 神秘单词, 随机选择 </p>
            <p>words = ['pizza', 'fairy', 'teeth', 'shirt', 'otter', 'plane'] </p>
            <p style="color: #dd6161">#从words数组中随机抽取一个单词,补全下方代码.  <span v-if="showAnswer">答案：{{answer1}}</span></p>
            <p>secret_word = <input type="text" v-model="yourAnswer1"></input>  </p>
            <p># print(secret_word)</p>
            <p>
              <br>
            </p>
            <p>clue = list('?????')</p>
            <p>heart_symbol = u'\u2764'</p>
            <p>
              <br>
            </p>
            <p>guessed_word_correctly = False</p>
            <p>
              <br>
            </p>
            <p>
              <br>
            </p>
            <p>def update_clue(guessed_letter, secret_word, clue):</p>
            <p> &nbsp; &nbsp;index = 0</p>
            <p> &nbsp; &nbsp;while index &lt; len(secret_word):</p>
            <p> &nbsp; &nbsp; &nbsp; &nbsp;if guessed_letter == secret_word[index]:</p>
            <p style="color: #dd6161"> &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp;#将猜到的正确单词复制给clue数组内对应位置 请填充下方代码。 <span v-if="showAnswer">答案： {{answer2}}</span></p>
            <p> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;clue[index] = <input type="text"  v-model="yourAnswer2"></input></p>
            <p> &nbsp; &nbsp; &nbsp; &nbsp;index = index + 1</p>
            <p>
              <br>
            </p>
            <p>
              <br>
            </p>
            <p>while lives &gt; 0:</p>
            <p> &nbsp; &nbsp;print(clue)</p>
            <p> &nbsp; &nbsp;print('剩余生命次数: ' + heart_symbol * lives)</p>
            <p> &nbsp; &nbsp;guess = input('猜测字母或者是整个单词: ')</p>
            <p>
              <br>
            </p>
            <p> &nbsp; &nbsp;if guess == secret_word:</p>
            <p style="color: #dd6161"> &nbsp; &nbsp; &nbsp; &nbsp;# 请填充下方变量. <span v-if="showAnswer">答案： {{answer3}}</span></p>
            <p> &nbsp; &nbsp; &nbsp; &nbsp;guessed_word_correctly = <input type="text" v-model="yourAnswer3"></input></p>
            <p> &nbsp; &nbsp; &nbsp; &nbsp;break</p>
            <p>
              <br>
            </p>
            <p> &nbsp; &nbsp;if guess in secret_word:</p>
            <p> &nbsp; &nbsp; &nbsp; &nbsp;update_clue(guess, secret_word, clue)</p>
            <p> &nbsp; &nbsp;else:</p>
            <p> &nbsp; &nbsp; &nbsp; &nbsp;print('错误。你丢了一条命\n')</p>
            <p> &nbsp; &nbsp; &nbsp; &nbsp;lives = lives - 1</p>
            <p> &nbsp; &nbsp; &nbsp; &nbsp;</p>
            <p>if guessed_word_correctly:</p>
            <p> &nbsp; &nbsp;print('你赢了! 秘密单词是 ' + secret_word)</p>
            <p>else:</p>
            <p> &nbsp; &nbsp;print('你输了! 秘密单词是 ' + secret_word)</p>
            <p>
              <br>
            </p>
          </div>
        </div>
      </div>
      <div style="width: calc(100vw - 950px);  text-align: left;  font-size: 15px; line-height: 25px; ">
        <div style="color: white; text-align: left; font-weight: bold; display: flex; justify-content: space-between; align-items: center">
          <span>
            运行效果：
          </span>
          <el-button type="success" @click="runCode">运行</el-button>
        </div>
        <div style="padding: 10px; background-color: white; margin-top: 5px; height: 600px;" >
          <div style="padding: 10px">
            <!--{{chooseWord}}-->
            <div v-html="tipInfo" >

            </div>
          </div>

        </div>
        <input type="text" ref="inputRef" id="inputVal" v-model="inputVal" @keydown="handleKeyDown" />
      </div>
    </div>
  </div>
</template>

<script>
  import { addExpScore } from '../../request/api';

  export default {
    data() {
      return {
        words: ['pizza', 'fairy', 'teeth', 'shirt', 'otter', 'plane'],
        //words: [ 'otter'],
        chooseWord: '',
        showWordArray: [],
        word: [],
        guess: '',
        chances: 3,
        message: '',
        zcdCode: [
          {ml: 0, con: "import random"},
          {ml: 0, con: "# 生命次数"},
          {ml: 0, con: "lives = 3"},
          {ml: 0, con: ""},
          {ml: 0, con: "# 神秘单词, 随机选择"},
          {ml: 0, con: "words = ['pizza', 'fairy', 'teeth', 'shirt', 'otter', 'plane']"},
          {ml: 0, con: "secret_word = random.choice(words)"},
          {ml: 0, con: "# print(secret_word)"},
          {ml: 0, con: ""},
          {ml: 0, con: "clue = list('?????')"},
          {ml: 0, con: "heart_symbol = '\u2764'"},
          {ml: 0, con: "guessed_word_correctly = False"},
          {ml: 0, con: ""},
          {ml: 0, con: "def update_clue(guessed_letter, secret_word, clue):"},
          {ml: 2, con: "index = 0"},
          {ml: 2, con: "while index < len(secret_word):"},
          {ml: 4, con: "if guessed_letter == secret_word[index]:"},
          {ml: 6, con: "clue[index] = guessed_letter"},
          {ml: 4, con: "index = index + 1"},
          {ml: 0, con: ""},
          {ml: 0, con: ""},
          {ml: 0, con: "while lives > 0:"},
          {ml: 2, con: "print(clue)"},
          {ml: 2, con: "print('剩余生命次数: ' + heart_symbol * lives)"},
          {ml: 2, con: "guess = input('猜测字母或者是整个单词: ')"},
          {ml: 0, con: ""},
          {ml: 2, con: "if guess == secret_word:"},
          {ml: 4, con: "guessed_word_correctly = True"},
          {ml: 4, con: "break"},
          {ml: 2, con: "if guess in secret_word:"},
          {ml: 4, con: "update_clue(guess, secret_word, clue)"},
          {ml: 2, con: "else:"},
          {ml: 4, con: "print('错误。你丢了一条命\n')"},
          {ml: 4, con: "lives = lives - 1"},
          {ml: 0, con: ""},
          {ml: 0, con: "if guessed_word_correctly:"},
          {ml: 2, con: "print('你赢了! 秘密单词是 ' + secret_word)"},
          {ml: 0, con: "else:"},
          {ml: 2, con: "print('你输了! 秘密单词是 ' + secret_word)"}
        ],
        tipInfo: '',
        canInput: false,
        inputVal: '',
        answer1: 'random.choice(words)',
        answer2: 'guessed_letter',
        answer3: 'True',
        answer4: '',
        answer5: '',
        yourAnswer1: '',
        yourAnswer2: '',
        yourAnswer3: '',
        yourAnswer4: '',
        yourAnswer5: '',
        scoreItemId: 'item123123',
        haveSubmit: false,
        showAnswer: false
      };
    },
    created() {

    },
    mounted() {
      //window.addEventListener('keydown', this.handleKeyDown);
    },
    methods: {

      runCode() {

        if (this.yourAnswer1 === '') {
          this.$message.error("请补全缺失的代码");
          return
        }
        if (this.yourAnswer2 === '') {
          this.$message.error("请补全缺失的代码");
          return
        }
        if (this.yourAnswer3 === '') {
          this.$message.error("请补全缺失的代码");
          return
        }

        let totalScore = 0;
        let fin = 1;
        if (this.answer1 === this.yourAnswer1) {
          totalScore += 30;
        } else {
          fin = 0;
        }
        if (this.answer2 === this.yourAnswer2) {
          totalScore += 40;
        } else {
          fin = 0;
        }
        if (this.answer3 === this.yourAnswer3) {
          totalScore += 30;
        } else {
          fin = 0;
        }

        if (fin === 0) {
          this.showAnswer = true;

          //
          if (!this.haveSubmit) {
            let param = {
              score: totalScore,
              expName: "猜词游戏"
            }
            addExpScore(param).then(
              resp => {
                if (resp.code === 1) {
                  this.msg = "提交成绩成功了,本次得分：" + totalScore + "分";
                  this.$message.success(this.msg);
                  this.haveSubmit = true
                } else {
                  this.msg = resp.msg;
                  this.$message.error(resp.msg);
                }
              }
            ).catch(err => {
              console.log(err)
            })
            this.$message.warning("请根据正确答案填充好缺失,再次运行");

          }
          return
        } else {
          if (!this.haveSubmit) {
            let param = {
              score: totalScore,
              expName: "猜词游戏"
            }
            addExpScore(param).then(
              resp => {
                if (resp.code === 1) {
                  this.msg = "提交成绩成功了,本次得分：" + totalScore + "分";
                  this.$message.success(this.msg);
                  this.haveSubmit = true
                } else {
                  this.msg = resp.msg;
                  this.$message.error(resp.msg);
                }
              }
            ).catch(err => {
              console.log(err)
            })
            this.$message.success("提交成绩成功了,本次得分：" + totalScore + "分");
            this.haveSubmit = true
          }
        }

        this.$nextTick(() => {
          this.$refs.inputRef.focus(); // 设置焦点
        });

        this.tipInfo = "";
        this.chances = 3
        this.chooseWord = this.words[Math.floor(Math.random() * this.words.length)];

        this.word = this.chooseWord.split('');
        this.showWordArray = new Array();
        for(let i = 0; i < this.word.length; i++) {
          this.showWordArray.push("?");
        }
        this.cai();
      },
      cai() {
        this.tipInfo += "<div>"+ JSON.stringify(this.showWordArray) +"</div>"
        this.tipInfo += "<div>剩余生命次数"+ this.getSm() +"</div>"
        this.tipInfo += "猜测字母或整个单词: "
        this.canInput = true;
      },
      handleKeyDown(event) {
        if (!this.canInput) {
          return
        }
        if (event.key == 'Enter') {
          this.tipInfo +=  this.inputVal

          this.checkGuess();
          if (this.canInput) {
            this.cai()
          }

          this.guess = '';
          this.inputVal = ''
        } else {
          this.guess += event.key;
        }

      },
      getSm() {
        let a = '';
        for (let i = 0 ; i < this.chances; i++) {
          a += '\u2764';
        }
        return a
      },
      checkGuess() {
        if (this.chances <= 0) {
          this.canInput = false
          return
        }
        if (this.guess.length === 1) {
          if (this.word.includes(this.guess)) {

            for (let i = 0; i < this.word.length; i += 1) {
              if (this.word[i] === this.guess) {
                this.showWordArray[i] = this.guess;
              }
            }
            let right = true;
            for(let i = 0; i < this.showWordArray.length; i++) {
              if (this.showWordArray[i] === "?") {
                right = false
              }
            }
            if (right) {
              this.message = '恭喜你，猜对了！';
              this.canInput = false
            }
          } else {
            this.chances -= 1;
            if (this.chances === 0) {
              this.message = '游戏结束';
            } else {
              this.message = `错误，你丢了一条命，还剩${this.chances}次机会`;
            }
          }
        } else if (this.guess === this.chooseWord) {
          this.message = '恭喜你，猜对了！';
          this.canInput = false
        } else {
          this.chances -= 1;
          if (this.chances === 0) {
            this.message = '游戏结束';
            this.canInput = false
          } else {
            this.message = `错误，你丢了一条命，还剩${this.chances}次机会`;
          }
        }
        this.guess = '';
        this.tipInfo += "<div>"+ this.message +"</div>"
        if (this.chances <= 0) {
          this.canInput = false
          return
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/lw/sz01.vue